import { api } from "../services/api";

/**
 * The address suggested to a new Keepo: asked as soon as its name is saved (/editor/title), so that /editor/publish,
 * a few steps later, finds it ready. One per Keepo, the last asked; a failure is a suggestion of none.
 */
const suggestions = new Map<string, Promise<string | null>>();

/** Asks for it now (again, after a new name), without waiting. */
export const startUrlSuggestion = (siteId: string) => {
  const suggestion = api.suggestUrl(siteId).catch(() => null);
  suggestions.set(siteId, suggestion);
  return suggestion;
};

/** The one asked when the name was saved, or a new one (a reload in between lost it). */
export const takeUrlSuggestion = (siteId: string) => suggestions.get(siteId) ?? startUrlSuggestion(siteId);

/** For tests: forgets every suggestion. */
export const clearUrlSuggestions = () => suggestions.clear();
